import { ValidationModel, ValidationType } from "@/services/validation/types";

export const propertiesValidators = {
    timeZone: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel,
    hourFormat: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel,
    format: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel
};
